
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getUnreadCount, getNotifications } from "../api/notifications";
import { Bell } from "lucide-react";
import { getLang } from "../store/uiStore";
import "./NotificationBell.css";

export default function NotificationBell() {
  const lang = getLang();

  const tr = {
    title: lang === "ru" ? "Уведомления" : "Хабарҳо",
    empty: lang === "ru" ? "Нет уведомлений" : "Хабаре нест",
    all: lang === "ru" ? "Все уведомления →" : "Ҳамаи хабарҳо →",
  };
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);

  const navigate = useNavigate();
  const ref = useRef();

  useEffect(() => {

    loadCount();

    const interval = setInterval(
      loadCount,
      30000
    );

    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener(
      "click",
      handleClickOutside
    );

    return () => {
      clearInterval(interval);

      document.removeEventListener(
        "click",
        handleClickOutside
      );
    };

  }, []);

  const loadCount = () => {
    getUnreadCount()
      .then((res) => setCount(res.data.count))
      .catch(() => setCount(0));
  };

  const loadNotifications = () => {
    getNotifications().then((res) => {
      setList(res.data.slice(0, 10));
    });
  };

  const toggle = () => {
    setOpen(!open);
    if (!open) loadNotifications();
  };

  const openAll = () => {
    setOpen(false); // 🔥 закрываем
    navigate("/notifications");
  };

  return (
    <div className="nizom-notification-bell" ref={ref}>
      <div
        className="nizom-notification-bell-button"
        onClick={toggle}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.background = "transparent")
        }
      >
        <Bell color="white" size={20} />

        {count > 0 && <span className="nizom-notification-badge">{count}</span>}
      </div>

      {open && (
        <div className="nizom-notification-dropdown">
          <div className="nizom-notification-dropdown-header">{tr.title}</div>

          {list.length === 0 && (
            <div className="nizom-notification-empty">{tr.empty}</div>
          )}

          {list.map((item) => (
            <div
              key={item.id}
              className={`nizom-notification-dropdown-item ${item.is_read ? "is-read" : "is-unread"}`}

              onClick={() => {

                setOpen(false);

                if (!item.is_read) {

                  import("../api/notifications")
                    .then(({ markAsRead }) =>
                      markAsRead(item.id)
                    )
                    .then(loadCount)
                    .catch(() => {});
                }

                if (item.url) {
                  navigate(item.url);
                } else {
                  navigate("/notifications");
                }
              }}

              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#f5f7fa";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = item.is_read
                  ? "#fff"
                  : "#eef4ff";
              }}
            >
              <div className={`nizom-notification-dropdown-title ${
                item.priority === "high"
                  ? "priority-high"
                  : item.priority === "medium"
                  ? "priority-medium"
                  : ""
              }`}>
                {item.title}
              </div>
              <div className="nizom-notification-dropdown-text">{item.message}</div>
            </div>
          ))}

          <div className="nizom-notification-dropdown-footer" onClick={openAll}>{tr.all}</div>
        </div>
      )}
    </div>
  );
}
